"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HTMLCurrencyOutputWidget = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var journey_services_1 = require("@athena-portal/journey-services");
var commonFunctions_1 = require("../../commonFunctions");
var react_html_parser_1 = require("react-html-parser");
var moment = require("moment");
var HTMLCurrencyOutputWidget = /** @class */ (function (_super) {
    __extends(HTMLCurrencyOutputWidget, _super);
    function HTMLCurrencyOutputWidget(props) {
        var _this = _super.call(this, props) || this;
        // Matches if there are any interaction fields present
        _this.INTERACTION_FIELD_TEST = /\{[\w.[\]]{1,100}\}/;
        // Matches first present interaction field
        _this.INTERACTION_FIELD_SPLIT = /(\{[\w.[\]]{1,100}\})/;
        // Matches interaction field inside curly braces
        _this.INTERACTION_FIELD_EXTRACT = /\{([\w.[\]]{1,100})\}/;
        return _this;
    }
    HTMLCurrencyOutputWidget.prototype.render = function () {
        var html = this.getSetting("html");
        var currencyCssClass = this.getSetting("currencyCssClass");
        if (!html) {
            throw Error("".concat(this.props.question.type, " widget is missing 'html' setting"));
        }
        return this.parseHtmlWithCurrency(html, currencyCssClass);
    };
    HTMLCurrencyOutputWidget.prototype.parseHtmlWithCurrency = function (html, className) {
        var _this = this;
        var transform = function (node) {
            if (node.type !== 'text') {
                return undefined;
            }
            var text = node.data;
            if (!_this.INTERACTION_FIELD_TEST.test(text)) {
                return;
            }
            var parts = text.split(_this.INTERACTION_FIELD_SPLIT);
            return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: parts.map(function (part) {
                    var match = _this.INTERACTION_FIELD_EXTRACT.exec(part);
                    if (match) {
                        var interactionField = match[1];
                        var interactionFieldValue = journey_services_1.ObjectManipulator.fetchFieldValue(interactionField, _this.props.interaction);
                        var formattedValue = _this.getFormattedValue(interactionFieldValue);
                        return ((0, jsx_runtime_1.jsx)("span", __assign({}, (className && { className: className }), { children: formattedValue }), interactionField));
                    }
                    return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: part });
                }) }));
        };
        return (0, react_html_parser_1.default)(html, { transform: transform });
    };
    HTMLCurrencyOutputWidget.prototype.getFormattedValue = function (value) {
        if (typeof value === 'number') {
            return (0, commonFunctions_1.getAmountToDisplay)(value);
        }
        if (typeof value === 'string') {
            var dateValue = moment.utc(value, moment.ISO_8601);
            if (dateValue.isValid()) {
                return dateValue.format("DD MMM YYYY");
            }
            return value;
        }
        return "";
    };
    return HTMLCurrencyOutputWidget;
}(plugin_journey_1.WidgetBase));
exports.HTMLCurrencyOutputWidget = HTMLCurrencyOutputWidget;
//# sourceMappingURL=HTMLCurrencyOutputWidget.js.map